module.exports = __webpack_public_path__ + "static/tiefling-sword-AYAGWW-616fba13bea664b28bf415ae3d6cb46b.png";